// Bootstrap JS - Bundled via Webpack
// -----------------------------------------------------------------------------
/* eslint-disable */

// Import Bootstrap's JavaScript (includes Popper.js)
import * as bootstrap from 'bootstrap';

// Make Bootstrap globally available
window.bootstrap = bootstrap;

// Auto-initialize all dropdowns with data-bs-toggle="dropdown"
document.addEventListener('DOMContentLoaded', () => {
  const dropdownElementList = document.querySelectorAll('[data-bs-toggle="dropdown"]');
  [...dropdownElementList].map(dropdownToggleEl => new bootstrap.Dropdown(dropdownToggleEl));
});

/* eslint-enable */

